import { useEffect, useState } from 'react';
const useLocalStorage = (storageKey, fallbackState) => {
    var _a;
    const [value, setValue] = useState((_a = JSON.parse(localStorage.getItem(storageKey))) !== null && _a !== void 0 ? _a : fallbackState);
    useEffect(() => {
        localStorage.setItem(storageKey, JSON.stringify(value));
    }, [value, storageKey]);
    return [value, setValue];
};
export default useLocalStorage;
